export const chars = {
    removeSpecialCharsOnTyping(event) {
        if (!/^[a-zA-Z0-9 ]+$/.test(event.target.value)) {
            event.target.value = event.target.value.replace(/[^a-z^A-Z^0-9^ ]/g, "");
        }
    },
}